import React from "react";
import { Card, CardContent } from "../../../components/ui/common/card";
import { LifecycleStage } from "../types";
import { LifecycleStageItem } from "./LifecycleStageItem";

interface LifecycleStagesCardProps {
  stages: LifecycleStage[];
  expandedStage: string | null;
  onToggleStage: (label: string) => void;
}

/**
 * LifecycleStagesCard Component
 * Single Responsibility: Display all lifecycle stages with breakdown
 */
export const LifecycleStagesCard: React.FC<LifecycleStagesCardProps> = ({
  stages,
  expandedStage,
  onToggleStage
}) => {
  return (
    <Card className="lg:tw-col-span-6 tw-border-border">
      <CardContent className="tw-p-1">
        <div className="tw-border-b tw-border-primary/20 tw-pb-2.5 tw-mb-2">
          <p className="tw-text-sm tw-font-semibold tw-text-primary">Impact by Life Cycle Stages</p>
        </div>
        <div className="tw-space-y-1">
          {stages.map(stage => (
            <LifecycleStageItem
              key={stage.label}
              stage={stage}
              isExpanded={expandedStage === stage.label}
              onToggle={() => onToggleStage(expandedStage === stage.label ? "" : stage.label)}
            />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
